/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import React, { useState, useEffect, useContext } from 'react';
import Alert from 'react-s-alert';
import { Button, Modal, ModalHeader, ModalFooter, ModalBody, Label, Table, Progress } from 'reactstrap';
import moment from 'moment';
import Joyride, { STATUS } from 'react-joyride';

// context imports
import { ThemeContext } from '../../contexts/ThemeContext';
import { AuthContext } from '../../contexts/AuthContext';

// service imports
import GeneralService from '../../services/GeneralService';

// local imports
import ErrorBoundary from '../general/ErrorBoundary';
import ClientNavbar from './ClientNavbar';
import SelectedProvider from './SelectedProvider';
import ClientService from '../../services/ClientService';
import Loading from '../../assets/UW_Horizontal_Logo_Full.png';
import Arrow from '../../assets/arrow.svg';
import FindProviderImg from '../../assets/active_support.svg';

const CancelSubscription = props => {

    // contexts
    const { theme, fontWeight, colors } = useContext(ThemeContext);
    const { user, setUser, selectedTimeZone } = useContext(AuthContext);

    // states
    const [selectedProvider, setSelectedProvider] = useState(null);
    const [currentClientSubscription, setCurrentClientSubscription] = useState(null);
    const [cancelModal, setCancelModal] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [disableSubmitBtn, setDisableSubmitBtn] = useState(false);
    const [tutorial, setTutorial] = useState({
        status: false,
        steps: [
            {
                content: <div className="tooltipDiv">View your current subscription details from here.</div>,
                placement: 'bottom',
                target: '#subscriptionDetailDiv',
            },
            {
                content: <div className="tooltipDiv">Confirm the cancellation by pressing here.</div>,
                placement: 'right',
                target: '#paymentBtn',
            }
        ]
    });
    let helpers = null;

    // useEffects

    useEffect(() => {
        try {
            if (props.location.state) {
                // console.log("states", props.location.state);
                setSelectedProvider(props.location.state.selectedProvider);
                setCurrentClientSubscription(props.location.state.currentSubscription);
                setIsLoading(false);
            }
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Client MakeSubscriptionPayment useEffect2', 'Error in try catch block', err.stack);
        }
    }, [props.location.state]);

    // handle functions
    const handleCancelPlan = e => {
        try {
            setDisableSubmitBtn(true);
            try {
                ClientService.cancelSubscription(currentClientSubscription.razorpaySubscriptionId).then(data => {
                    // console.log("data", data);
                    setCancelModal(false);
                    setDisableSubmitBtn(false);
                    props.history.push('subscription');
                }).catch(err => {
                    console.log("err3", err);
                    setCancelModal(false);
                    setDisableSubmitBtn(false);
                    Alert.error("Some error occured, please try again later or report support team.", {
                        position: 'top-right',
                        effect: 'slide'
                    });
                });
            } catch (err) {
                console.log("err2", err);
                setCancelModal(false);
                setDisableSubmitBtn(false);
                Alert.error("Some error occured, please try again later or report support team.", {
                    position: 'top-right',
                    effect: 'slide'
                });
                // GeneralService.logError('at BookSession handleSubmit', err.stack);
            }
        } catch (err) {
            setCancelModal(false);
            setDisableSubmitBtn(false);
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            // GeneralService.logError('at BookSession handleSubmit', err.stack);
        }
    }

    const handleJoyrideCallback = (data) => {
        const { status, type } = data;
        const finishedStatuses = [STATUS.FINISHED, STATUS.SKIPPED];

        if (finishedStatuses.includes(status)) {
            // if (!user.guideTakenFor.includes("ClientDashboard")) {
            //     AuthService.markVisited("ClientDashboard");
            //     setUser({ ...user, guideTakenFor: [...user.guideTakenFor, "ClientDashboard"] });
            // }
            // AuthService.markVisited("ClientDashboard");
            setTutorial({ ...tutorial, status: false });
        }
    };

    const getHelpers = (paramHelpers) => {
        helpers = paramHelpers;
    };

    // function's return
    return (
        <div>
            <ErrorBoundary errorAt="At Client CancelSubscription Joyride">
                <Joyride
                    callback={handleJoyrideCallback}
                    continuous={true}
                    getHelpers={getHelpers}
                    run={tutorial.status}
                    scrollToFirstStep={true}
                    showProgress={false}
                    showSkipButton={true}
                    steps={tutorial.steps}
                    locale={{ last: 'Finish' }}
                    styles={{
                        options: {
                            primaryColor: "rgb(56, 78, 115)",
                            zIndex: 10000,
                        },
                    }}
                />
            </ErrorBoundary>
            <ClientNavbar history={props.history} showTutorial={() => setTutorial({ ...tutorial, status: true })} />
            {
                isLoading ?
                    <img className="mx-auto d-block" height="auto" width="40%" src={Loading} alt="Loading..." />
                    :
                    <div className="p-2">
                        <div>
                            <div className="text-center">
                                <h1 style={{ fontFamily: "Montserrat, sans-serif", fontSize: "1.8rem", fontWeight: "500", color: "#384E73" }}>Cancel Current Plan</h1>
                                <h2 style={{ fontFamily: "Montserrat, sans-serif", fontSize: "1.2rem", fontWeight: "500" }}>Your existing plan will be cancelled.<br />You will be able to use your existing plan benefits till end of the cycle.</h2>
                            </div>
                            <div className="pt-4" style={{ fontWeight: "500" }}>Current Subscription Plan Details</div>
                            <hr />
                            <ErrorBoundary errorAt="At Client Subsciptions SelectedProvider">
                                <SelectedProvider
                                    selectedProvider={selectedProvider}
                                />
                            </ErrorBoundary>
                            <Table id="subscriptionDetailDiv" className='mt-3' borderless>
                                <tbody>
                                    <tr>
                                        <td style={{ width: '30%' }}>
                                            <span style={{ fontWeight: fontWeight.medium }}>Subscription Plan</span>
                                        </td>
                                        <td>
                                            <span>{currentClientSubscription.clientSubscriptionPlan.name}</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <span style={{ fontWeight: fontWeight.medium }}>Call Sessions</span>
                                        </td>
                                        <td className="d-flex">
                                            <Progress className="successProgress my-auto mr-2" value={(100 * currentClientSubscription.serviceDetails.call.currentCycleUsage) / currentClientSubscription.clientSubscriptionPlan.serviceDetails.call} /><span>{`${currentClientSubscription.serviceDetails.call.currentCycleUsage} / ${currentClientSubscription.clientSubscriptionPlan.serviceDetails.call}`}</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <span style={{ fontWeight: fontWeight.medium }}>Video Sessions</span>
                                        </td>
                                        <td className="d-flex">
                                            <Progress className="successProgress my-auto mr-2" value={(100 * currentClientSubscription.serviceDetails.video.currentCycleUsage) / currentClientSubscription.clientSubscriptionPlan.serviceDetails.video} /><span>{`${currentClientSubscription.serviceDetails.video.currentCycleUsage} / ${currentClientSubscription.clientSubscriptionPlan.serviceDetails.video}`}</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <span style={{ fontWeight: fontWeight.medium }}>Messaging</span>
                                        </td>
                                        <td className="d-flex">
                                            <span>Unlimited</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <span style={{ fontWeight: fontWeight.medium }}>Start Date</span>
                                        </td>
                                        <td>
                                            <span>{moment.unix(currentClientSubscription.subsciptionStartDate).format("MMM DD, dddd")}</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <span style={{ fontWeight: fontWeight.medium }}>Days Passed</span>
                                        </td>
                                        <td className="d-flex">
                                            <Progress className="successProgress my-auto mr-2" value={(100 * currentClientSubscription.currentCycleDaysGone) / currentClientSubscription.currentCycleTotalDays} /><span>{`${currentClientSubscription.currentCycleDaysGone}/${currentClientSubscription.currentCycleTotalDays}`}</span>
                                        </td>
                                    </tr>
                                    {/* <tr>
                                                    <td>
                                                        <span style={{ fontWeight: fontWeight.medium }}>Expires On</span>
                                                    </td>
                                                    <td>
                                                        <span>Unlimited</span>
                                                    </td>
                                                </tr> */}
                                </tbody>
                            </Table>
                            <div>
                                <button className="btn mx-auto mt-4" id="paymentBtn" type="button" style={theme.buttonDanger} disabled={disableSubmitBtn} onClick={() => setCancelModal(true)}>
                                    {disableSubmitBtn ? <span className="spinner-border spinner-border-sm mr-1"></span> : null}Cancel Plan
                                </button>
                            </div>
                            <br />
                            <text>*Subscription will be cancelled at the end of current cycle.</text>
                        </div>
                    </div>
            }
            <Modal size="lg" isOpen={cancelModal} backdrop={true}>
                <ModalHeader close={<span className="ml-3" style={{ cursor: "pointer" }} onClick={() => setCancelModal(false)}><i className="fas fa-times"></i></span>}><span style={theme.headingBold}>Cancel Plan</span></ModalHeader>
                <ModalBody>
                    <Label>By clicking on Continue button your subscription will be cancelled and you won't be charged about this in future.<br />You can still enjoy the benefits of the current subscription untill the current cycle ends.</Label>
                </ModalBody>
                <ModalFooter>
                    <Button type="button" style={theme.formButton} className="btn" disabled={disableSubmitBtn} onClick={() => handleCancelPlan()}>
                        {disableSubmitBtn ? <span className="spinner-border spinner-border-sm mr-1"></span> : null}Continue
                    </Button>
                </ModalFooter>
            </Modal>
        </div>
    )

}

export default CancelSubscription;